import { createContext } from 'react';
import type { PublicEvent } from '../types';

export interface EventManagerContextValue {
  isLoading: boolean;
  syncError: string | null;
  storageMode: 'bliss' | 'local';
  events: PublicEvent[];
  publishedEvents: PublicEvent[];
  featuredEvent: PublicEvent | null;
  createEvent: () => PublicEvent;
  saveEvent: (event: PublicEvent) => Promise<PublicEvent>;
  deleteEvent: (eventId: string) => Promise<void>;
  setFeaturedEvent: (eventId: string) => Promise<void>;
  resetEvents: () => Promise<void>;
  getEventBySlug: (slug: string) => PublicEvent | undefined;
}

export const EventManagerContext = createContext<EventManagerContextValue | null>(null);
